module.exports = __webpack_public_path__ + "static/2-3ed2676135f9fec1771a855e33604e91.jpg";